// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1UHT-","inputWrap":"styles_inputWrap__2majz","input":"styles_input__2qVnW"};